var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAddUser = function SvgIconAddUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 8.5,
    stroke: "#979797",
    strokeDasharray: "7 7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.165 25.2031V13.9033C25.165 13.458 25.5254 13.0977 25.9707 13.0977C26.416 13.0977 26.7764 13.458 26.7764 13.9033V25.2002H38.0732C38.5186 25.2002 38.8789 25.5605 38.8789 26.0059C38.8789 26.4512 38.5186 26.8115 38.0732 26.8115H26.7764V38.1084C26.7764 38.5537 26.416 38.9141 25.9707 38.9141C25.5254 38.9141 25.165 38.5537 25.165 38.1084V26.8174H13.8652C13.4199 26.8174 13.0596 26.457 13.0596 26.0117C13.0596 25.5664 13.4199 25.2061 13.8652 25.2061H25.165V25.2031Z",
    fill: "#979797"
  })));
};
export default SvgIconAddUser;